const BASE_PIXEL_SIZE = 16;

export default function rems(input) {
  const regex = /^(^-?\d+(?:\.\d+)?)(.*)$/;
  const matches = input.match(regex);
  if (matches) {
    const parsedNum = parseInt(input, 10);
    return `${parsedNum / BASE_PIXEL_SIZE}rems`;
  }
  throw new Error(
    `Invalid input: ${input}. Must be in the form of a number followed by a px. ie: 16px, -16px.`,
  );
}
